import { z } from 'zod'

export const registerSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Please enter a valid email address'),
  phoneNumber: z.string().min(10, 'Please enter a valid phone number'),
  password: z.string()
    .min(6, 'Password must be at least 6 characters')
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).+$/,
      'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  confirmPassword: z.string(),
  vehicleType: z.string().min(1, 'Please select a vehicle type'),
  vehicleNumber: z.string().min(1, 'Please enter your vehicle number'),
  licenseNumber: z.string().min(1, 'Please enter your license number'),
}).refine((data) => data.password === data.confirmPassword, {
  message: "Passwords don't match",
  path: ["confirmPassword"],
})

export type RegisterFormValue = z.infer<typeof registerSchema>

export const loginSchema = z.object({
  password: z.string().min(6, 'Password must be at least 6 characters'),
  phone: z.string().min(10, 'Please enter a valid phone number')
})

export type LoginFormValue = z.infer<typeof loginSchema>

export const uploadSchema = z.object({
  // profilePhoto: z
  //   .instanceof(File)
  //   .refine((file) => file.size <= 2 * 1024 * 1024, "Max size 2MB"),
  // vehiclePhotos: z
  //   .array(z.instanceof(File).refine((file) => file.size <= 2 * 1024 * 1024, "Max size 2MB"))
  //   .nonempty("At least one vehicle photo is required"),
  driversLicense: z
    .instanceof(File, { message: "Driver's License is required" })
    .refine((file) => file.size <= 2 * 1024 * 1024, "Max size 2MB"),

  vehicleRegistration: z
    .instanceof(File, { message: "Vehicle Registration is required" })
    .refine((file) => file.size <= 2 * 1024 * 1024, "Max size 2MB"),

  insurance: z
    .instanceof(File, { message: "Insurance is required" })
    .refine((file) => file.size <= 2 * 1024 * 1024, "Max size 2MB"),
  // bankDetails: z.object({
  //   accountName: z.string().min(1, "Account name is required"),
  //   accountNumber: z.string().regex(/^\d{10}$/, "Must be a 10-digit account number"),
  //   bankCode: z.string().min(1, "Bank code required"),
  //   bankName: z.string().min(1, "Bank name required"),
  // }),
});

export type UploadFormData = z.infer<typeof uploadSchema>;